import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from '@blueprint/ui';
import { FormFooter } from "../../../common/components/form";

import PublicFormContainer from "./PublicFormContainer";

const ResetPasswordSuccessMessage = (): JSX.Element => {
    const history = useHistory();

    return (
        <PublicFormContainer>
            <h2 className="mb-4">
                You have successfully changed your password.
            </h2>
            <p className="mb-5">
                You may now login to Enterprise DLT Payment Service with your new password.
            </p>
            <FormFooter className="d-flex mb-5">
                <Button
                onClick={()=> history.push("/login")}
                className="btn btn-primary flex-grow-1"
                variant="light.primary">Back To Login</Button>
            </FormFooter>
        </PublicFormContainer>
    );
};

export default ResetPasswordSuccessMessage;
